(function () {
    let bl = [document.getElementsByClassName("bl")];

    bl.push(document.getElementsByClassName("pBtn"))
    for (let j = 0; j < bl.length; j++) {

        for (let i = 0; i < bl[j].length; i++) {
            const insights = bl[j][i].closest(".insights")
            if (insights) {
                console.log("insights button", insights.style.color);
                bl[j][i].style.borderColor = insights.style.color;
                bl[j][i].style.color = insights.style.color;
            }

            const computedStyle = window.getComputedStyle(bl[j][i])
            const color = computedStyle.color == "rgba(0, 0, 0, 0)" ? "rgb(255, 255, 255)" : computedStyle.color;

            const backgroundColor = computedStyle.backgroundColor == "rgba(0, 0, 0, 0)" ? "rgb(255, 255, 255)" : computedStyle.backgroundColor;

            if (!insights) {
                bl[j][i].style.backgroundColor = backgroundColor;
            }


            const borderColor = computedStyle.borderColor == "rgba(0, 0, 0, 0)" ? backgroundColor : computedStyle.borderColor;
            const rgbBg = getRGBColors(borderColor);
            const backgroundRGB = getRGBColors(backgroundColor);
            const colorRGB = getRGBColors(color);


            const foregroundColor = invertRGB(...backgroundRGB);
            if (!insights) {
                bl[j][i].style.color = foregroundColor;
            }


            if (rgbBg) {

                const invertedBorderColor = invertRGB(...rgbBg);
                const invertedBackgroundColor = invertRGB(...backgroundRGB);
                const invertedColor = invertRGB(...colorRGB);

                bl[j][i].addEventListener("mouseover", function () {
                    if (borderColor == backgroundColor) {
                        //console.log(foregroundColor)
                        this.style.borderColor = backgroundColor
                        this.style.backgroundColor = foregroundColor
                        this.style.color = foregroundColor == "#000000" ? "#ffffff" : backgroundColor;
                    }
                    else {
                        this.style.backgroundColor = borderColor;
                        //console.log("hover", bl[j][i].style.borderColor, invertedBorderColor, invertedBackgroundColor);
                        this.style.color = invertedBorderColor;
                        if (this.closest(".insights")) {
                            //this.style.backgroundColor = invertedBackgroundColor
                        }
                    }
                    //if (borderColor == "rgba(0, 0, 0, 0)") {
                    //    this.style.borderColor = color;
                    //    this.style.color = bl[j][i].style.borderColor;
                    //    this.dataset.borderColor = "rgba(0, 0, 0, 0)";
                    //}

                    //console.log("hover", borderColor == "rgba(0, 0, 0, 0)", borderColor, invertedColor, bl[j][i].style.borderColor);
                })
                bl[j][i].addEventListener("mouseout", function () {
                    if (borderColor == backgroundColor) {
                        this.style.borderColor = backgroundColor
                        this.style.backgroundColor = backgroundColor
                        this.style.color = foregroundColor;
                    } else {
                        this.style.borderColor = borderColor
                        this.style.backgroundColor = backgroundColor
                        this.style.color = foregroundColor;
                        if (insights) {
                            bl[j][i].style.color = borderColor;
                            bl[j][i].style.backgroundColor = "transparent";
                        }

                    }


                    //this.style.backgroundColor = backgroundColor;
                    //this.style.color = color;
                    //if (this.dataset.borderColor) {
                    //    this.style.borderColor = this.dataset.borderColor;
                    //    this.dataset.borderColor = null;
                    //}
                })
            }
        }
    }

    function getRGBColors(color) {
        const rgbValues = color.match(/\d+/g);
        if (rgbValues) {
            return rgbValues.map(Number);
        } else {
            console.error("Invalid border color format:", color);
            return null;
        }
    }

    function invertRGB(r, g, b) {
        return (r * 0.299 + g * 0.587 + b * 0.114) > 160
            ? '#000000'
            : '#FFFFFF';
    }

})();